import React, { memo, useMemo, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useOrder } from "../../hooks/useOrder";
import { handleConfirmation } from "../handleConfirmation";
import { useAccountInfo } from "../../hooks/useAccountInfo";
import DataGridTable from "../dataGrid/DataGridTable";
import { PageTitle } from "../pageTitle/PageTitle";
import { Typography } from "@mui/material";
import { DataGridWrapper } from "../dataGrid/DataGridWrapper";
import { useSupportTickets } from "../../hooks/useSupportTickets";
import { dateTimeColumnDef } from "../dateTimeColumnDef";
import {
  supportTicketNumber,
  supportTicketParcelTrackingCode,
  supportTicketStatus,
  supportTicketCreatedAt,
  supportTicketIssue,
  supportTicketOpenInfoButton,
} from "../reusableSupportTicketColumns";

export const SupportTickets = memo(() => {
  const [selectedDates, setSelectedDates] = useState();
  const { t } = useTranslation();
  const { tickets, loading, fetchSupportTickets } = useSupportTickets(selectedDates);

  const columns = useMemo(
    () => [
      supportTicketNumber(t),
      supportTicketParcelTrackingCode(t),
      supportTicketStatus(t),
      supportTicketIssue(t),
      supportTicketCreatedAt(t),
      supportTicketOpenInfoButton(t),
    ],
    [t],
  );

  const handleDateChange = useCallback(
    (dates) => {
      setSelectedDates(dates);
    },
    [setSelectedDates],
  );

  return (
    <DataGridWrapper>
      <DataGridTable
        title={<PageTitle title={t("pagesTitles.supportTickets")} />}
        showCalendar={true}
        autoHeight={false}
        selectedDates={selectedDates}
        onDateChange={handleDateChange}
        showOtherTablesHeader
        rows={tickets}
        columns={columns}
        onRefresh={fetchSupportTickets}
        loading={loading}
        emptyTableText={
          <Typography className={"text-center pt-8"}>
            {t("supportTicketsDataGrid.noTickets")}
          </Typography>
        }
      />
    </DataGridWrapper>
  );
});
